module.exports = __webpack_public_path__ + "img/LeonardoIcon.21ab510d.svg";